function PageHeader({ title, description, action, compact = false }) {
  const headerClass = compact
    ? 'mx-auto mb-4 flex w-full max-w-4xl flex-col items-center gap-2 text-center'
    : 'mx-auto mb-8 flex w-full max-w-4xl flex-col items-center gap-4 text-center';
  const titleClass = compact
    ? 'max-w-full break-words text-2xl font-bold leading-tight sm:text-3xl'
    : 'max-w-full break-words text-3xl font-bold leading-tight sm:text-4xl';
  const descriptionClass = compact
    ? 'max-w-3xl text-pretty text-sm leading-6 text-gray-800'
    : 'max-w-3xl text-pretty text-base leading-7 text-gray-800 sm:text-lg';

  return (
    <header className={headerClass}>
      <h1 className={titleClass}>
        {title}
      </h1>
      {action}
      {description && (
        <p className={descriptionClass}>
          {description}
        </p>
      )}
    </header>
  );
}

export default PageHeader;
